import React from 'react'
import Footer from '../components/footerComponent/footer'
import MyStudent from '../components/teacherComponent/myStudentComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function MyStudentPage() {
    return (
        <Layout>
            <Header/>
            <MyStudent/>
            <Footer/>
        </Layout>
    );
};